/**
 * The hosts that serve real visitors (8 Oct 2026). Only a request to one of
 * these hosts can send a lead. Every other host is test only. This is an
 * allowlist: a new host is test only until someone adds it here.
 */
export const PRODUCTION_HOSTS: ReadonlySet<string> = new Set([
  "restorehair.com",
  "www.restorehair.com",
  "lp.restorehair.com",
]);

export function isProductionHostname(hostname: string): boolean {
  return PRODUCTION_HOSTS.has(hostname.trim().toLowerCase().replace(/\.$/u, ""));
}

/** Browser only: true on a host that is not a production host. */
export function isPreviewBrowserHost(): boolean {
  if (typeof window === "undefined") return false;
  return !isProductionHostname(window.location.hostname);
}
